import * as React from 'react';
import { DashboardRoot, DashboardComponent, DashboardComponentPlaceholder, } from './Dashboard.styled';
import { ComponentProvider } from '../../ComponentProvider/ComponentProvider';
import { DashboardError } from './DashboardError';
import { generateDashboardLayout, debounce, generateFluidDashboardLayout, } from '../Dashboard.utils';
export function Dashboard(props) {
    const { config, forceFluid, renderPlaceholder, renderError } = props;
    const [dashboardWidth, setDashboardWidth] = React.useState(0);
    const dashboardRoot = React.useRef(null);
    const updateDashboardWidth = () => {
        if (!dashboardRoot.current)
            return;
        const width = dashboardRoot.current.getBoundingClientRect().width;
        setDashboardWidth(width);
    };
    const debouncedUpdateDashboardWidth = debounce(() => {
        if (!dashboardRoot.current)
            return;
        const width = dashboardRoot.current.getBoundingClientRect().width;
        setDashboardWidth(width);
    }, 200);
    React.useLayoutEffect(() => {
        updateDashboardWidth();
    }, []);
    React.useEffect(() => {
        window.addEventListener('resize', debouncedUpdateDashboardWidth);
        return () => {
            window.removeEventListener('resize', debouncedUpdateDashboardWidth);
        };
    }, []);
    const { components, height, config: newConfig } = forceFluid
        ? generateFluidDashboardLayout(config, dashboardWidth)
        : generateDashboardLayout(config, dashboardWidth);
    return (React.createElement(DashboardRoot, { height: height, ref: dashboardRoot }, dashboardWidth &&
        components.map((componentConfig) => (React.createElement(DashboardComponent, Object.assign({ key: componentConfig.id }, newConfig, componentConfig),
            React.createElement(ComponentProvider, { config: componentConfig, data: componentConfig.data, renderPlaceholder: () => (React.createElement(DashboardComponentPlaceholder, null)), renderError: () => (React.createElement(DashboardError, null)) }))))));
}
//# sourceMappingURL=Dashboard.js.map